import { ProtectedImg } from "./ProtectedMedia";
import { Link } from "react-router-dom";
import { abs, money, TYPE_LABELS } from "../lib/api";

export const TypeBadge = ({ type }) => (
  <span
    className="inline-block px-2.5 py-1 text-[0.6rem] uppercase tracking-[0.2em] font-mono"
    style={{
      background: type === "physical_art" ? "var(--wb-emerald)" : "transparent",
      color: type === "physical_art" ? "#F4F4F6" : "var(--wb-gold)",
      border: type === "physical_art" ? "none" : "1px solid var(--wb-line-accent)",
    }}
  >
    {TYPE_LABELS[type]}
  </span>
);

export const ProductCard = ({ p, aspect = "aspect-[4/5]", index = 0 }) => (
  <Link
    to={`/product/${p.slug}`}
    data-testid="product-card-item"
    data-product-slug={p.slug}
    className="group block fade-up"
    style={{ animationDelay: `${index * 70}ms` }}
  >
    <div className={`art-frame ${aspect}`}>
      <ProtectedImg src={abs(p.image_urls[0])} alt={p.title} loading="lazy" className={`h-full w-full object-cover ${p.sold_out ? "grayscale opacity-60" : ""}`} />
      <div className="absolute left-4 top-4"><TypeBadge type={p.type} /></div>
      <div className="absolute bottom-4 right-4">
        <span className="price-tag" data-testid="product-card-price">{p.sold_out ? "Sold out" : money(p.price)}</span>
      </div>
    </div>
    <div className="mt-5 flex items-start justify-between gap-4">
      <div>
        <h3 className="font-display text-2xl leading-tight tracking-tight group-hover:text-wb-gold transition-colors duration-300">{p.title}</h3>
        <p className="mt-1 text-xs muted">{p.subtitle}</p>
      </div>
      {p.year && <span className="font-mono text-xs muted pt-2">{p.year}</span>}
    </div>
  </Link>
);
